import { io } from "socket.io-client";

const server = `${process.env.REACT_APP_API}`;
const webSocket = io(server);

webSocket.on("connect", () => {
  console.log(`Websocket conectado!`);
});
webSocket.on("disconnect", (reason) => {
  if (reason === "io server disconnect") {
    webSocket.connect();
  }
  console.log(`Websocket desconectado, ${reason}`);
});

export default webSocket;
